var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine57(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 77",
    overflow: "scroll",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    fill: "#6E6E00",
    width: 120,
    height: 77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.6318016,69.8173828c-6.9419022,0-12.2754021-1.5244141-16.8466015-4.3173828l4.8251991-9.3125 c3.3017006,2.2860985,6.6879005,3.8096008,11.3437023,3.8096008c4.6562996,0,10.4975967-2.7940025,10.4975967-9.8203011 c0-4.3173981-2.8784981-10.2431984-13.8832989-10.4122009c-3.3867989,0-7.3652992-0.0848999-9.3125-0.0848999 l2.3705997-31.0688992H55.033699v9.9897995H33.5312996l-0.8466988,11.3437004c0.3382988,0,1.1005974,0.085001,1.6927986,0.085001 c16.3389015,0.7616997,22.9419022,9.9892998,22.9419022,18.9628983 C57.3193016,60.419899,48.2612,69.8173828,34.6318016,69.8173828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M80.7108994,68.3779297H67.0820007c0-7.8730278,2.1161957-12.9521294,7.365303-22.6875305 l14.5604935-27.0897999H59.9706993V8.6107998h41.8203011v9.7354012 C88.6688995,41.1190987,80.7108994,58.9813995,80.7108994,68.3779297z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine57);
export default __webpack_public_path__ + "static/media/line-57.b83dea1f38295f2ba55818e1fd4fd548.svg";
export { ForwardRef as ReactComponent };